/* RefineDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
/** @jsxFrag */

import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl-next';
import DropdownMenu from '@atlaskit/dropdown-menu';
import messages from './messages';
import { RefineDropdownItems } from './RefineDropdownItems';
export function RefineDropdown(_ref) {
  var items = _ref.items,
    onClick = _ref.onClick;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpened = _useState2[0],
    setIsOpened = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentOpenedSubMenu = _useState4[0],
    setCurrentOpenedSubMenu = _useState4[1];
  var handleOpenChange = useCallback(function (_ref2) {
    var isOpen = _ref2.isOpen;
    isOpen && onClick && onClick();
    setIsOpened(isOpen);
    if (!isOpen) {
      setCurrentOpenedSubMenu(null);
    }
  }, [onClick]);
  var handleItemClick = useCallback(function () {
    setIsOpened(false);
    setCurrentOpenedSubMenu(null);
  }, []);
  var handleSubMenuOpenChanged = useCallback(function (subMenu, isOpen) {
    setCurrentOpenedSubMenu(function (current) {
      // Close the current opened sub menu if it's not the same as the one that was clicked
      if (current === subMenu && !isOpen) {
        return null;
      }
      return subMenu;
    });
  }, []);
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    trigger: formatMessage(messages.refineButton),
    testId: "refine-dropdown",
    shouldRenderToParent: true,
    isOpen: isOpened,
    onOpenChange: handleOpenChange
  }, /*#__PURE__*/React.createElement(RefineDropdownItems, {
    items: items,
    onItemClick: handleItemClick,
    currentOpenedSubMenu: currentOpenedSubMenu,
    onSubMenuOpenChanged: handleSubMenuOpenChanged
  }));
}